import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { Coordinate } from '../../../models/heatmap/coordinate';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ModalController } from '@ionic/angular';
import { ExpandedHeatmapModalPage } from '../../expanded-heatmap-modal/expanded-heatmap-modal.page';

declare let h337: any;

@Component({
  selector: 'app-scene-heatmap',
  templateUrl: './scene-heatmap.component.html',
  styleUrls: ['./scene-heatmap.component.scss'],
})
export class SceneHeatmapComponent implements OnInit {

  public gradientCfg = {
    '0.15': '#6ad180',
    '0.25': '#7cd573',
    '0.35': '#90d865',
    '0.45': '#a4da57',
    '0.55': '#badc48',
    '0.65': '#c9cf35',
    '0.75': '#d6c226',
    '0.80': '#e2b41c',
    '0.85': '#e2961d',
    '0.90': '#dd7826',
    '0.95': '#d25c30',
    '1.0': '#c24039'
  };
  heatmap: any = null;
  coordinates: Array<Coordinate> = [];
  heatmapContainer: HTMLElement;
  sceneId: any = 0;
  public paginateConfig: any;

  @Input('scene') scene: Scene;
  @Input('cameraTracking') cameraTracking: any[];
  @Input('lookedAtMedia') lookedAtMedia: any[];
  @Input('currentSceneMedia') currentSceneMedia: AssetInScene[];
  @Input('noAssets') noAssets: boolean = false;

  constructor(
    public assetTypeService: AssetTypeService,
    private modalController: ModalController
  ) {
    this.paginateConfig = {
      itemsPerPage: 3,
      currentPage: 1
    };
  }


  ngOnChanges() {
    if (this.scene.sceneId != this.sceneId) {
      this.sceneId = this.scene.sceneId;

      if (document.querySelector(".heatmap-canvas") != null)
        document.querySelector(".heatmap-canvas").remove();
      var max = this.generateCoordinates(336, 665);
      setTimeout(() => {
        var heatMapContainer = document.querySelector(".heatmap-container-" + this.scene.sceneId);
        const heatmapConfig = {
          container: document.querySelector(".heatmap-container-" + this.scene.sceneId),
          opacity: .8,
          radius: 7,
          visible: true,
          gradient: this.gradientCfg,
          backgroundColor: 'inherit'
        };

        this.heatmap = h337.create(heatmapConfig);
        this.heatmap.setData({ max: max, data: this.coordinates });
      }, 1000);
    }
  }

  ngOnInit() {
    if (this.scene.sceneId != this.sceneId) {
      this.sceneId = this.scene.sceneId;

      if (document.querySelector(".heatmap-canvas") != null)
        document.querySelector(".heatmap-canvas").remove();
      var max = this.generateCoordinates(336, 665);
      setTimeout(() => {
        var heatMapContainer = document.querySelector(".heatmap-container-" + this.scene.sceneId);
        const heatmapConfig = {
          container: document.querySelector(".heatmap-container-" + this.scene.sceneId),
          opacity: .8,
          radius: 7,
          visible: true,
          gradient: this.gradientCfg,
          backgroundColor: 'inherit'
        };
        this.heatmap = h337.create(heatmapConfig);
        this.heatmap.setData({ max: max, data: this.coordinates });
      }, 1000);
    }
  }


  eventHandler() {
    // 
  }

  generateCoordinates(HEATMAP_HEIGHT, HEATMAP_WIDTH) {

    this.coordinates = [];

    var pi = Math.PI;
    this.cameraTracking.forEach(trackItem => {
      var rotx = trackItem.rotation.y * (180 / pi);
      var roty = trackItem.rotation.x * (180 / pi);

      roty += 90;
      rotx += 90;

      while (rotx < 0)
        rotx = rotx + 360;

      while (roty < 0)
        roty = roty + 180;

      while (rotx > 360)
        rotx = rotx - 360;

      while (roty > 180)
        roty = roty - 180;

      roty = 180 - roty;
      rotx = 360 - rotx;

      var width = HEATMAP_WIDTH / 360;
      var height = HEATMAP_HEIGHT / 180;

      var calcx = Math.round(rotx * width);
      var calcy = Math.round(roty * height);

      this.coordinates.push({ x: calcx, y: calcy, value: 1 });
    });
    var max = 0;
    this.coordinates.forEach(coord => {
      var len = this.coordinates.filter(x => x.x >= coord.x - 5 && x.x <= coord.x + 5 && x.y >= coord.y - 5 && x.y <= coord.y + 5).length;
      coord.value = len;
      if (max < len)
        max = len;
    });

    return max;
  }

  isColouredBackground(scene: Scene) {
    if (scene != null && scene.sceneBackgroundFileType == "") {
      return true;
    }
    return false;
  }

  getMediaCount(baseAssetId) {
    var count = this.lookedAtMedia.filter(x => x.baseAssetId == baseAssetId).length;
    if (count != null) {
      return count;
    }
    return 0;
  }

  getMediaType(assetTypeId) {
    let type = this.assetTypeService.getType(assetTypeId);

    if (type == 'Invisible') {
      type = 'Object Selection Tool';
    }

    if (type == 'Model3D') {
      type = '3D Model';
    }

    if (type == 'QuestionSet') {
      type = 'Quiz';
    }

    if (type == 'Question') {
      type = 'Single Question';
    }

    return type;
  }

  hasNoAssets() {
    if (this.currentSceneMedia.length == 0) {
      this.noAssets = true;
    }
    else {
      this.noAssets = false;
    }
    return this.noAssets;
  }

  getCurrentMedia() {
    return this.currentSceneMedia;
  }

  async expandHeatmap() {
    const modal = await this.modalController.create({
      component: ExpandedHeatmapModalPage,
      id: 'expanded-heatmap-modal',
      componentProps: {
        "scene": this.scene,
        "cameraTracking": this.cameraTracking
      }
    });

    return await modal.present();
  }
}